import Model from "../Model";

class RepresentantRelations extends Model{

    buildUrl ({ param }) {
        return ['/agent/getrelation', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new RepresentantRelations;